import React, { useRef, useEffect } from 'react';
import Icon from 'components/AppIcon';

const VideoModal = ({ isOpen, onClose, videoUrl, title }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (isOpen && videoRef?.current) {
      videoRef?.current?.play();
    } else if (!isOpen && videoRef?.current) {
      videoRef?.current?.pause();
      videoRef.current.currentTime = 0;
    }
  }, [isOpen]);

  const handleBackdropClick = (e) => {
    if (e?.target === e?.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
      onClick={handleBackdropClick}
    >
      <div className="relative max-w-4xl w-full bg-black rounded-lg overflow-hidden animate-in slide-in-from-bottom-5 duration-300">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-organic"
          aria-label="Close video"
        >
          <Icon name="X" size={20} />
        </button>

        {/* Video Header */}
        {title && (
          <div className="absolute top-0 left-0 right-0 z-10 bg-gradient-to-b from-black/60 to-transparent p-6 pb-12">
            <h3 className="text-white text-xl font-heading font-semibold">
              {title}
            </h3>
          </div>
        )}

        {/* Video Player */}
        <div className="relative aspect-video">
          <video
            ref={videoRef}
            className="w-full h-full object-cover"
            controls
            playsInline
            preload="metadata"
          >
            <source src={videoUrl} type="video/mp4" />
            <track kind="captions" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Video Controls Overlay */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6 pt-12">
          <div className="flex items-center justify-between text-white">
            <div className="flex items-center space-x-4">
              <Icon name="Play" size={16} className="text-white/80" />
              <span className="text-sm text-white/80 font-body">
                Dandeli Adventure Resort Experience
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Volume2" size={16} className="text-white/80" />
              <Icon name="Maximize" size={16} className="text-white/80" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;